export const TELEMEDICINE_LOG_DEFAULT_SORT = {
  sortedColumn: 'startTime',
  sortedColumnOrder: 'ascend'
}
